import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import actions from '../../modules/common';
import messages from './messages';

const styles = {
  serviceAlert: {
    alignItems: 'center',
    backgroundColor: 'primary.main',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '40px',
    position: 'fixed',
    px: 4,
    py: 1,
    textAlign: 'center',
    top: 0,
    width: '100%',
    zIndex: 3000,
  },
  text: {
    color: '#f5f5f5',
  },
};

export interface IServiceAlertProps {
  show: boolean;
}

export function ServiceAlert({ show }: IServiceAlertProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.setServiceAlertShow(show));

    if (show) {
      const listenerAction = () => {
        dispatch(actions.setServiceAlertHeight(document.getElementById('serviceAlert')?.clientHeight));
      };
      window.addEventListener('resize', listenerAction);
      return () => {
        window.removeEventListener('resize', listenerAction);
      };
    }
  }, [show]);

  useEffect(() => {
    dispatch(actions.setServiceAlertHeight(document.getElementById('serviceAlert')?.clientHeight));
  }, []);

  return (
    show && (
      <Box id="serviceAlert" sx={styles.serviceAlert}>
        <Typography sx={styles.text}>
          <FormattedMessage {...messages.serviceAlertText} />
        </Typography>
      </Box>
    )
  );
}
